import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient.js";
import "../../styles/DiamondsMaster.css";

function DiamondsMaster() {
  const [size, setSize] = useState("");
  const [color, setColor] = useState("WHITE");

  const [totalQty, setTotalQty] = useState(1000);
  const [totalWeight, setTotalWeight] = useState("");
  const weightPerStone = totalWeight && totalQty ? (totalWeight / totalQty).toFixed(6) : 0;

  const [diamonds, setDiamonds] = useState([]);
  const [editItem, setEditItem] = useState(null);

  const fetchDiamonds = async () => {
    const { data, error } = await supabase
      .from("DIAMONDS")
      .select("*")
      .order("size", { ascending: true });

    if (!error) setDiamonds(data);
  };

  useEffect(() => {
    fetchDiamonds();
  }, []);

  const addDiamond = async () => {
    if (!size.trim() || !totalWeight) {
      alert("Enter size and weight!");
      return;
    }

    const { error } = await supabase.from("DIAMONDS").insert([
      {
        size,
        color,
        total_quantity: totalQty,
        total_weight: totalWeight,
        weight_per_stone: weightPerStone
      }
    ]);

    if (!error) {
      setSize("");
      setTotalWeight("");
      setTotalQty(1000);
      fetchDiamonds();
    }
  };

  const deleteDiamond = async (id) => {
    if (!window.confirm("Delete this diamond?")) return;

    const { error } = await supabase.from("DIAMONDS").delete().eq("id", id);
    if (!error) fetchDiamonds();
  };

  const saveEdit = async () => {
    const newWeightPerStone = (
      editItem.total_weight / editItem.total_quantity
    ).toFixed(6);

    const { error } = await supabase
      .from("DIAMONDS")
      .update({
        size: editItem.size,
        color: editItem.color,
        total_quantity: editItem.total_quantity,
        total_weight: editItem.total_weight,
        weight_per_stone: newWeightPerStone
      })
      .eq("id", editItem.id);

    if (!error) {
      setEditItem(null);
      fetchDiamonds();
    }
  };

  return (
    <div className="diamond-page">
      <h2 className="page-title">💎 Diamonds Master</h2>

      {/* Add Diamond Card */}
      <div className="diamond-card">
        <div className="diamond-card-title">➕ Add Diamond</div>

        <div className="input-row">
          <div className="input-group">
            <label>Diamond Size:</label>
            <input
              type="text"
              value={size}
              onChange={(e) => setSize(e.target.value)}
              placeholder="e.g. 1.20"
            />
          </div>

          <div className="input-group">
            <label>Diamond Color:</label>
            <select value={color} onChange={(e) => setColor(e.target.value)}>
              <option value="WHITE">WHITE</option>
              <option value="YELLOW">YELLOW</option>
              <option value="BLACK">BLACK</option>
            </select>
          </div>
        </div>

        <div className="input-row">
          <div className="input-group">
            <label>Total Quantity:</label>
            <input
              type="number"
              value={totalQty}
              onChange={(e) => setTotalQty(e.target.value)}
            />
          </div>

          <div className="input-group">
            <label>Total Weight (g):</label>
            <input
              type="number"
              value={totalWeight}
              onChange={(e) => setTotalWeight(e.target.value)}
              placeholder="e.g. 0.90"
            />
          </div>
        </div>

        <div className="input-group">
          <label>Weight per Stone:</label>
          <input type="text" value={weightPerStone} readOnly />
        </div>

        <button className="main-btn" onClick={addDiamond}>
          Add Diamond
        </button>
      </div>

      {/* Table */}
      <table className="diamond-table">
        <thead>
          <tr>
            <th>Size</th>
            <th>Color</th>
            <th>Total Qty</th>
            <th>Total Weight</th>
            <th>Weight/Stone</th>
            <th style={{ width: "160px" }}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {diamonds.length === 0 ? (
            <tr>
              <td colSpan="6" className="no-records">
                No Records Found
              </td>
            </tr>
          ) : (
            diamonds.map((d) => (
              <tr key={d.id}>
                <td>{d.size}</td>
                <td>{d.color}</td>
                <td>{d.total_quantity}</td>
                <td>{d.total_weight}</td>
                <td>{d.weight_per_stone}</td>
                <td>
                  <div className="action-buttons">
                    <button
                      className="edit-btn"
                      onClick={() => setEditItem(d)}
                    >
                      Edit
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => deleteDiamond(d.id)}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* EDIT POPUP */}
      {editItem && (
        <div className="popup-overlay">
          <div className="popup-card">
            <h3>Edit Diamond</h3>

            <div className="input-group">
              <label>Diamond Size</label>
              <input
                type="text"
                value={editItem.size}
                onChange={(e) =>
                  setEditItem({ ...editItem, size: e.target.value })
                }
              />
            </div>

            <div className="input-group">
              <label>Diamond Color</label>
              <select
                value={editItem.color}
                onChange={(e) =>
                  setEditItem({ ...editItem, color: e.target.value })
                }
              >
                <option value="WHITE">WHITE</option>
                <option value="YELLOW">YELLOW</option>
                <option value="BLACK">BLACK</option>
              </select>
            </div>

            <div className="input-group">
              <label>Total Quantity</label>
              <input
                type="number"
                value={editItem.total_quantity}
                onChange={(e) =>
                  setEditItem({
                    ...editItem,
                    total_quantity: e.target.value,
                  })
                }
              />
            </div>

            <div className="input-group">
              <label>Total Weight (g)</label>
              <input
                type="number"
                value={editItem.total_weight}
                onChange={(e) =>
                  setEditItem({
                    ...editItem,
                    total_weight: e.target.value,
                  })
                }
              />
            </div>

            <div className="input-group">
              <label>Weight per Stone</label>
              <input
                type="text"
                value={
                  editItem.total_weight && editItem.total_quantity
                    ? (editItem.total_weight / editItem.total_quantity).toFixed(6)
                    : 0
                }
                readOnly
              />
            </div>

            <div className="popup-actions">
              <button className="main-btn" onClick={saveEdit}>
                Save
              </button>
              <button className="delete-btn" onClick={() => setEditItem(null)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DiamondsMaster;
